/**
 * @voltxampere/ui — PTC thermistor variant (Sprint 43-6)
 *
 * Positive-temperature-coefficient thermistor — resistance INCREASES
 * with temperature, often used for over-current / over-temperature
 * protection. Default 100 Ω at 25 °C; resistance climbs sharply past
 * the Curie point (~120-140 °C).
 *
 * Reference: TDK / Murata PTC family. Engine zero-diff invariant
 * honored — canonical `resistor` engine type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { resistor } from "../resistor.js";
export const sensorPtc = {
    id: "ptc",
    nameTr: "PTC (pozitif sıcaklık katsayılı, koruma)",
    nameEn: "PTC (positive temperature coefficient, protection)",
    shortcut: "R",
    category: "passive",
    viewBox: resistor.viewBox,
    terminals: resistor.terminals,
    defaultLabel: "R",
    defaultValue: "100Ω@25°C",
    schemaType: "resistor",
    defaultParams: { resistance: 100 },
    renderSVG: () => resistor.renderSVG(),
};
//# sourceMappingURL=sensor-ptc.js.map